export default function route(page: string) {
  switch (page) {
    case 'label-studio-project-list':
      import('./label-studio-project-list.js')
      return page

    case 'label-studio-project-create':
      import('./label-studio-project-create.js')
      return page

    case 'label-studio-label':
      import('./label-studio-label-page.js')
      return page
  }
}
